
import dsBridgeSDK from "../assets/js/dsBridge";

/**
 *  端上的方法
 * @param {string} sendData h5传递给app的数据
 * @param {function} callback 回调方法,接收app传递的数据
 */

export const getData = (callBack) => {
  dsBridgeSDK.callNativeHandler("getData", {}, callBack);
};

export const changeActionBar = (params = {}, callBack) => {
  dsBridgeSDK.callNativeHandler("changeActionBar", params, callBack);
};
// aio分享
export const nativeShowAioShare = (data) => {
  console.log(data)
  dsBridgeSDK.callNativeHandler("showAioShare", data || {});
}
// toast
export const nativeToast = (message = '', timer = 3) => {
  console.log('nativeToast', message)
  message && dsBridgeSDK.callNativeHandler('nativeToast', { message, timer });
};
// 播放视频
export const playVideo = (data, callback) => {
  console.log('playVideo', data)
  const { resource_vod_src = '', resource_src = '' } = data || {};
  (resource_vod_src || resource_src) && dsBridgeSDK.callNativeHandler("playVideo", data, callback);
}

export const getClientCommonMessage = (params = {}, callBack) => {
  dsBridgeSDK.callNativeHandler("getClientCommonMessage", params, callBack);
};
// 获取状态栏高度
export const getStatusBarInfo = (params = {}, callBack) => {
  console.log('getStatusBarInfo')
  dsBridgeSDK.callNativeHandler("getStatusBarInfo", params, callBack);
};

// actionBar返回
export const nativeGoBack = (params = {}, callBack) => {
  console.log('goBack')
  dsBridgeSDK.callNativeHandler("goBack", params, callBack);
};

// 页面跳转
export const doJump = (path, callBack) => {
  if (!path.includes('com.tal.publish.book')) {
    path = `xueersi://com.tal.publish.book/${path}`;
  } 
  console.log({
    url: path
  },'path')
  dsBridgeSDK.callNativeHandler("doJump", {
    url: path
  }, callBack);
};

// 初始化获取nry_question_id
export const getNryQuestionId = (callBack) => {
  dsBridgeSDK.callNativeHandler("getNryQuestionId", {}, callBack);
};

// 注销账号
export const deleteAccount = (params = {}, callBack) => {
  console.log('调用注销账号2')
  dsBridgeSDK.callNativeHandler("deleteAccount", params, callBack);
};

// 跳登录
export const goLogin = (params = {}, callBack) => {
  dsBridgeSDK.callNativeHandler("login", params, callBack);
};

// 获取设备信息 
export const getDeviceInfo = (callBack) => {
  dsBridgeSDK.callNativeHandler("deviceInfo", {}, callBack);
};

// 视频弹窗
export const showActiveAlert = (params = {}, callBack) => {
  dsBridgeSDK.callNativeHandler("showActiveAlert", params, callBack);
};

// 再拍一次 
export const reTakePhoto = (callBack) => {
  dsBridgeSDK.callNativeHandler("reTakePhoto", {}, callBack);
};

//nativeConfirm
export const nativeConfirm = (params = {}, callBack) => {
  dsBridgeSDK.callNativeHandler("nativeConfirm", params, callBack);
};

// 微信分享
export const wxShare = (params = {}, callBack) => {
  dsBridgeSDK.callNativeHandler("wxShare", params, callBack);
};

// 选择图片
interface ITakeResources {
  [propName: string]: string | number;
  type: string;
  maxCount: number;
}
export const takeResources = (params: ITakeResources = {} as ITakeResources, callBack = () => {}) => {
  if(!params.type) {
    nativeToast('请标记选择资源的来源-type')
    return
  }
  if(!params.sourceType) {
    nativeToast('请标记选择资源的类型-sourceType')
    return
  }
  if (!params?.maxCount) {
    nativeToast('maxCount为大于0的数字')
    return
  }
  dsBridgeSDK.callNativeHandler("takeResources", params, callBack);
}
// 预览图片
export const previewResources = (params = { data: [], initIndex: 0 }, callBack = () => {}) => {
  if (!params?.data?.length) {
    nativeToast('不存在预览资源')
    return
  }
  params.initIndex = params.initIndex || 0
  dsBridgeSDK.callNativeHandler("previewResources", params, callBack);
}
// 上传图片
export const nativeUploadResources = (params = {from: '', data: []}) => {
  dsBridgeSDK.callNativeHandler("uploadResources", params, (res) => {
    console.log(res)
  });
}

// 取消图片上传
export const cancelUploadResource = () => {
  dsBridgeSDK.callNativeHandler("cancelUploadResource", {}, (res) => {
    console.log(res)
  });
}

// dotWebReady 
export const dotWebReady = () => {
  dsBridgeSDK.callNativeHandler("wvinvp.dotWebReady", {}, (res) => {
    console.log(res)
  });
}
// 给客户端传递答题结果
export const receiveDotAnswer = (data = {}, cb) => {
  dsBridgeSDK.callNativeHandler("wvinvp.receiveDotAnswer", data, (res) => {
    cb && cb(res)
  });
}
// 取消倒计时
export const resetCountTime = () => {
  dsBridgeSDK.callNativeHandler("wvinvp.resetCountTime", {}, (res) => {
    console.log(res)
  });
}
// 关键点日志
export const writeLog = (data) => {
  // console.log(data, '关键点日志')
  dsBridgeSDK.callNativeHandler("wvinvp.writeLog", data, (res) => {
    console.log(res)
  });
}
// 调用端上的埋点方法
export const sensorsAnaticEvent = (event_id='', info = {} as {event_name: string; event_type: string; [attrName: string]: string;}) => {
  if (!(event_id && info.event_name && info.event_type)) {
    nativeToast('事件id、名称、类型必传')
    return
  }
  dsBridgeSDK.callNativeHandler("wvinvp.sensorsAnaticEvent", {
    event_id,
    info
  }, (res) => {
    console.log(res)
  });
}

// g
export const closeHalfView = (data) => {
  dsBridgeSDK.callNativeHandler("wvinvp.closeHalfView", data, (res) => {
    console.log(res)
  });
}